import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";
import ApplicantWorkflow from "../ApplicantWorkflow";
import { Pill } from "./PipelineTable";

export default function CandidateDrawer({ sel, onClose, onChanged }) {
  if (!sel) return null;
  return (
    <Dialog open onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="bg-slate-900 border-slate-700 text-white max-w-3xl max-h-[88vh] overflow-y-auto" data-testid="candidate-drawer">
        <DialogHeader><DialogTitle className="display uppercase text-2xl">{sel.name}</DialogTitle></DialogHeader>
        {sel.fa_profile && <div className="flex flex-wrap gap-2 text-[11px]" data-testid="drawer-report-strip">
          <Pill tone="sky">FA profile: {sel.fa_profile.raw}</Pill>{sel.screening?.background && <Pill tone="amber">Background: {sel.screening.background.raw}</Pill>}{sel.screening?.drug && <Pill tone="slate">Drug: {sel.screening.drug.status}</Pill>}{sel.screening?.physical && <Pill tone="slate">Physical: {sel.screening.physical.raw}</Pill>}{sel.screening?.missing?.length > 0 && <Pill tone="amber">missing: {sel.screening.missing.join(", ")}</Pill>}{sel.flags?.map((f) => <Pill key={f} tone="rose">{f}</Pill>)}
          <span className="text-slate-500">from imported reports (read-only) · report {sel.fa_profile.report_date ? new Date(sel.fa_profile.report_date).toLocaleDateString() : "—"}</span></div>}
        <ApplicantWorkflow kind={sel.kind} recordId={sel.id} onChanged={onChanged} />
      </DialogContent>
    </Dialog>
  );
}
